import { TrackAttendanceCtrl } from './track-attendance.controller';

export const TrackAttendanceComponent = {
  controller: TrackAttendanceCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
    currentSchool: '<',
    schoolSupports: '<',
  },
  template: require('./track-attendance.html'),
};
